import { useIntl } from 'react-intl';
import { getCenter, formatArea } from 'client/utils/helpers/Aoi';
import styles from './WorkpackMapInfo.module.scss';

const WorkpackMapInfo = ({ aoi }) => {
    const intl = useIntl();
    const center = getCenter(aoi);
    const area = formatArea(aoi.getGeometry());

    return (
        <><p className="govuk-body-s">
            <span className="govuk-!-font-weight-bold" data-testid="printPreview.coords.label">
                {intl.formatMessage({ id: 'mapPreview.coordinates' }) + ': '}
            </span>
            <span className={styles.infoValue} data-testid="printPreview.coords.value">
                {`${center[0].toFixed(2)}, ${center[1].toFixed(2)}`}
            </span>
        </p><p className="govuk-body-s">
            <span className="govuk-!-font-weight-bold" data-testid="printPreview.areaSize.label">
                {intl.formatMessage({ id: 'mapPreview.area' }) + ': '}
            </span>
            <span className={styles.infoValue} data-testid="printPreview.areaSize.value">
                {area}
            </span>
        </p></>
    );
};

export default WorkpackMapInfo;
